import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';

import { Listing } from 'components/shared/TableListing';
import { QuoteChargeProfitability, DealerProfitabilityListingEntity } from '../../../types';
import { DealerProfitabilityListingColumns } from './dealerProfitabilityListingConfig';

interface Props {
  profitability: QuoteChargeProfitability;
}

export const DealerProfitability = ({ profitability }: Props) => {
  const { netSellingPrice, totalDealerCost, grossProfit, marginRate } = profitability;

  const tableData = useMemo<DealerProfitabilityListingEntity>(
    () => ({ netSellingPrice, totalDealerCost, grossProfit, marginRate }),
    [netSellingPrice, totalDealerCost, grossProfit, marginRate]
  );

  return (
    <Listing<DealerProfitabilityListingEntity>
      tableData={[tableData]}
      columns={DealerProfitabilityListingColumns}
      actionPanelTop={() => (
        <Stack>
          <Typography variant="h6" component="span">
            Dealer Profitability
          </Typography>
        </Stack>
      )}
    />
  );
};
